import { defineMessage } from 'react-intl';

export type SourceFilter = 'all' | 'face' | 'voice' | 'unknown';

/** Messages for the Personas results-table tab. */
export const personsViewMessages = {
  filterAll: defineMessage({
    id: 'logger.persons.filter.all',
    defaultMessage: 'Todas',
  }),
  filterFace: defineMessage({
    id: 'logger.persons.filter.face',
    defaultMessage: 'Con rostro',
  }),
  filterVoice: defineMessage({
    id: 'logger.persons.filter.voice',
    defaultMessage: 'Con voz',
  }),
  filterUnknown: defineMessage({
    id: 'logger.persons.filter.unknown',
    defaultMessage: 'No identificadas',
  }),
  title: defineMessage({
    id: 'logger.persons.track.title',
    defaultMessage: 'Personas',
  }),
  sources: defineMessage({
    id: 'logger.persons.table.sources',
    defaultMessage: 'Fuentes',
  }),
  onScreen: defineMessage({
    id: 'logger.persons.table.onScreen',
    defaultMessage: 'En pantalla',
  }),
  speaking: defineMessage({
    id: 'logger.persons.table.speaking',
    defaultMessage: 'Hablando',
  }),
  appearances: defineMessage({
    id: 'logger.persons.table.appearances',
    defaultMessage: 'Apariciones',
  }),
  actions: defineMessage({
    id: 'common.text.actions',
    defaultMessage: 'Acciones',
  }),
  timeline: defineMessage({
    id: 'logger.persons.table.timeline',
    defaultMessage: 'Apariciones en el foco',
  }),
  appearancesDetail: defineMessage({
    id: 'logger.persons.table.appearancesDetail',
    defaultMessage: 'Detalle de apariciones',
  }),
  confidence: defineMessage({
    id: 'logger.persons.table.confidence',
    defaultMessage: 'Confianza',
  }),
};
